export default __webpack_public_path__ + "static/media/H0001.1d2ddbdc.png";